import { Mark, mergeAttributes } from "@tiptap/core";

export interface InlineThreadAttributes {
  "data-thread-id": string;
}

export const InlineThread = Mark.create({
  name: "inlineThread",
  excludes: "",
  inclusive: false,
  keepOnSplit: true,

  addAttributes() {
    return {
      "data-thread-id": {
        default: "",
        parseHTML: (element) => element.getAttribute("data-thread-id"),
        renderHTML: (attributes) => {
          if (!attributes["data-thread-id"]) {
            return {};
          }
          return {
            "data-thread-id": attributes["data-thread-id"],
          };
        },
      },
    };
  },

  parseHTML() {
    return [
      {
        tag: "span[data-inline-thread]",
        getAttrs: (node) => {
          if (!(node instanceof HTMLElement)) return false;
          return {
            "data-thread-id": node.getAttribute("data-thread-id"),
          };
        },
      },
    ];
  },

  renderHTML({ HTMLAttributes }) {
    return [
      "span",
      mergeAttributes(HTMLAttributes, {
        "data-inline-thread": "",
      }),
      0,
    ];
  },
});
